"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractFilteredVariantsCommand = void 0;
const AbstractVariantCommand_1 = require("./AbstractVariantCommand");
class AbstractFilteredVariantsCommand extends AbstractVariantCommand_1.AbstractVariantCommand {
    constructor() {
        super(...arguments);
        this.filter = {};
        this.withVariantID = (variantID) => {
            this.filter.variantID = variantID;
            return this;
        };
        this.withName = (name) => {
            this.filter.name = name;
            return this;
        };
        this.withType = (type) => {
            this.filter.type = type;
            return this;
        };
        this.withFilter = (filter) => {
            this.filter = {
                ...this.filter,
                ...filter,
            };
            return this;
        };
        this.applyVariantFilter = (variants) => {
            if (this.filter) {
                return variants.filter(variant => (!this.filter.name || this.filter.name === variant.name) &&
                    (!this.filter.description || this.filter.description === variant.description) &&
                    (!this.filter.variantID || this.filter.variantID === variant.variantID) &&
                    (!this.filter.developer || this.filter.developer === variant.developer) &&
                    (!this.filter.type || this.filter.type === variant.type));
            }
            return variants;
        };
    }
}
exports.AbstractFilteredVariantsCommand = AbstractFilteredVariantsCommand;
//# sourceMappingURL=AbstractFilteredVariantsCommand.js.map